function getDeliveryDate() {
  const daysOfWeek = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
  const monthsOfYear = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

  // Obtener la fecha y hora actual en zona horaria de México
  let today = luxon.DateTime.now().setZone('America/Mexico_City').toISO();
  today = new Date(today);

  const currentHour = today.getHours();
  const currentDay = today.getDay();

  let deliveryDate = new Date(today);

  // Lunes a Jueves
  if (currentDay >= 1 && currentDay <= 4) {
    if (currentHour < 12) {
      return "hoy mismo";
    } else {
      deliveryDate.setDate(today.getDate() + 1);
    }
  }

  // Viernes
  else if (currentDay === 5) {
    if (currentHour < 12) {
      return "hoy mismo";
    } else {
      // Enviar hasta lunes
      deliveryDate.setDate(today.getDate() + 3);
    }
  }

  // Sábado o Domingo - siempre enviar el lunes
  else if (currentDay === 6 || currentDay === 0) {
    const daysUntilMonday = currentDay === 6 ? 2 : 1;
    deliveryDate.setDate(today.getDate() + daysUntilMonday);
  }

  const dayName = daysOfWeek[deliveryDate.getDay()];
  const monthName = monthsOfYear[deliveryDate.getMonth()];
  const day = deliveryDate.getDate();

  return `${dayName}, ${day} de ${monthName}`;
}

document.addEventListener('DOMContentLoaded', function () {
  const dateElement = document.getElementById('date__estimated');
  if (dateElement) {
    let date = getDeliveryDate();
    dateElement.textContent = date;
  }
});
